var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterpolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "waterpolo.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 4.3994184,
    inkscapeCx: 23.75314,
    inkscapeCy: 81.94265,
    "inkscapWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 7.1337439,15.946682 0.017215,-0.03485 C 7.3911659,15.447536 7.6888398,15.048474 8.0223206,14.727799 L 4.6196729,14.624435 2.4726743,10.952794 C 2.2054698,10.495559 1.6187015,10.34136 1.1614698,10.608836 0.70464974,10.876171 0.55086044,11.463229 0.81820004,11.920041 l 2.41501376,4.130005 c 0.1666029,0.284691 0.4679809,0.46355 0.7981669,0.474168 l 2.7950585,0.08502 c 0.1014236,-0.222285 0.2036939,-0.443159 0.3073047,-0.662551",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23.197269,16.62398 c -0.204505,-0.488245 -0.766621,-0.717833 -1.254442,-0.513186 l -2.826491,1.186356 -2.945413,0.09317 c 0.09797,0.650135 -0.06269,1.3214 -0.463973,1.895475 -0.0088,0.0127 -0.01806,0.02494 -0.02674,0.03764 l 3.67397,-0.116028 c 0.117157,-0.0039 0.232339,-0.02924 0.340395,-0.07444 l 2.990074,-1.254831 c 0.487821,-0.204928 0.71755,-0.766198 0.512621,-1.25416",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.184663,14.283652 c -0.597112,1.426704 -2.100828,2.155966 -3.359503,1.629551 -1.258853,-0.527121 -1.795463,-2.109929 -1.198351,-3.536597 0.596829,-1.426704 2.101074,-2.156214 3.359926,-1.629128 1.258711,0.526697 1.794757,2.109928 1.197928,3.536174",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.8108817,23.404757 C 7.2488201,23.261565 7.708807,23.182472 8.212609,23.16635 c 0.069462,-0.0029 0.1456619,-0.0043 0.2233789,-0.0043 0.4229453,0 0.8246181,0.04685 1.1939412,0.138924 0.3974399,0.09564 0.7634469,0.258904 1.1025719,0.432153 1.218882,-1.632303 2.909323,-3.369734 4.074019,-5.071463 0.513327,-0.729968 0.319017,-1.544779 -0.243205,-2.034117 -0.570371,0.352072 -1.219024,0.552027 -1.882422,0.552027 -0.442348,0 -0.87242,-0.08597 -1.278538,-0.256434 -0.864729,-0.361598 -1.4983176,-1.057664 -1.8359612,-1.901438 -0.5411612,0.182316 -1.0825693,0.697019 -1.4425084,1.392803 -1.0568165,2.23654 -2.0495685,4.656913 -1.9887849,6.904249 0.00303,0.104317 0.044344,0.213043 0.112007,0.317359 0.1923697,-0.09483 0.3795184,-0.17212 0.5637742,-0.231387",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30.415985,24.638809 c -0.351966,0.05856 -0.695219,0.198543 -1.005558,0.34036 -0.312525,0.140405 -0.60138,0.258939 -0.901911,0.309774 -0.300567,0.055 -0.603603,0.06107 -0.924278,0.0339 -0.306458,-0.02551 -0.609636,-0.08047 -0.87503,-0.182033 -0.269417,-0.09948 -0.506166,-0.24377 -0.790999,-0.431447 -0.281128,-0.187711 -0.637892,-0.397579 -1.029123,-0.523944 -0.387244,-0.129822 -0.796078,-0.18729 -1.166495,-0.200378 -0.392465,-0.01446 -0.79114,0.0082 -1.203043,0.109432 -0.40954,0.09881 -0.797066,0.294605 -1.094987,0.453214 -0.302613,0.160549 -0.531107,0.26363 -0.776676,0.324943 -0.247332,0.06149 -0.50613,0.08227 -0.808884,0.07444 -0.130528,-0.0046 -0.279611,-0.01545 -0.408587,-0.03309 -0.132433,-0.01831 -0.256893,-0.04519 -0.375391,-0.08114 -0.238548,-0.07169 -0.450885,-0.185212 -0.745102,-0.359837 -0.289948,-0.170463 -0.682413,-0.382412 -1.102148,-0.499957 -0.416031,-0.12058 -0.846808,-0.162595 -1.225515,-0.163266 -0.211526,0.0011 -0.40319,0.01129 -0.612952,0.03665 -0.20641,0.02547 -0.417653,0.06625 -0.626321,0.126365 -0.419594,0.117404 -0.813012,0.327695 -1.10229,0.500204 -0.294463,0.174625 -0.507259,0.288854 -0.745772,0.360221 -0.23936,0.07306 -0.494877,0.106115 -0.797772,0.11564 -0.275872,0.0081 -0.554496,-0.01298 -0.795796,-0.07444 -0.245992,-0.06103 -0.475156,-0.162595 -0.777064,-0.324238 C 10.226476,24.392535 9.8399377,24.196038 9.4305391,24.098036 9.0238568,23.996365 8.6090607,23.9728 8.2390673,23.987546 c -0.3928886,0.01267 -0.7847894,0.07056 -1.1771136,0.199672 -0.3910895,0.12566 -0.7475715,0.335527 -1.0291234,0.523522 -0.2848328,0.188348 -0.5222876,0.331964 -0.7913865,0.431871 -0.2687461,0.101953 -0.561975,0.156527 -0.8826501,0.18161 -0.3065992,0.02783 -0.6199787,0.02152 -0.917635,-0.0332 -0.300549,-0.0514 -0.5896646,-0.170074 -0.9020634,-0.310338 -0.3099224,-0.142205 -0.6530517,-0.282646 -1.005004,-0.341207 -0.3522275,-0.05747 -0.70279996,-0.05609 -1.04262416,-0.0088 0.3396866,0.0477 0.67262026,0.117123 0.97496136,0.246662 0.3059254,0.123331 0.5698208,0.303318 0.8481837,0.499533 0.276158,0.198191 0.5943459,0.399909 0.9513959,0.529449 0.3570499,0.132292 0.7274666,0.194451 1.099947,0.22158 0.3587045,0.02537 0.7491237,0.01161 1.135239,-0.07369 0.3881967,-0.0816 0.7579078,-0.257987 1.0612262,-0.4082 0.3071636,-0.151694 0.5576711,-0.260702 0.8246181,-0.316794 0.2622197,-0.05817 0.5536847,-0.0678 0.8405989,-0.05472 0.309245,0.01446 0.5779559,0.05927 0.8261351,0.144957 0.248038,0.08407 0.4686653,0.207821 0.7592836,0.388478 0.286103,0.177095 0.664351,0.395359 1.076396,0.515409 0.204082,0.06283 0.411903,0.106221 0.615315,0.134055 0.206692,0.02854 0.396981,0.04191 0.60646,0.04618 0.376485,0.0092 0.804369,-0.02604 1.219694,-0.140017 0.419488,-0.110102 0.81347,-0.316548 1.107546,-0.480942 0.298732,-0.166053 0.512762,-0.274779 0.751029,-0.33969 0.118215,-0.03238 0.24197,-0.05567 0.37345,-0.07013 0.128023,-0.01489 0.276437,-0.0212 0.404707,-0.02081 0.300849,-3.88e-4 0.553579,0.02607 0.792233,0.09208 0.237878,0.06491 0.452543,0.173214 0.750923,0.341453 0.294322,0.164007 0.68901,0.369747 1.108604,0.480131 0.208386,0.05609 0.418924,0.09426 0.624276,0.115746 0.208774,0.02286 0.399767,0.02783 0.609353,0.02399 0.376484,-0.0081 0.801335,-0.05542 1.208828,-0.18094 0.411868,-0.120297 0.790434,-0.338313 1.076361,-0.515796 0.290089,-0.180657 0.509905,-0.304412 0.758225,-0.386962 0.243064,-0.08544 0.527897,-0.130634 0.814811,-0.145097 0.308821,-0.01298 0.5836,-0.0024 0.851076,0.05539 0.266524,0.05581 0.516643,0.16577 0.824089,0.317217 0.303283,0.149931 0.673841,0.32632 1.06232,0.407776 0.389431,0.08502 0.769902,0.09839 1.142682,0.07302 0.358564,-0.02755 0.739176,-0.08999 1.093329,-0.222285 0.357047,-0.129787 0.675358,-0.331541 0.951372,-0.530119 0.278377,-0.19625 0.542149,-0.376061 0.847795,-0.499534 0.302331,-0.129962 0.635282,-0.199001 0.974831,-0.247367 -0.33969,-0.04727 -0.69028,-0.04907 -1.042776,0.0082",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.4175568,7.2683477 c 0,1.4468123 -1.1729862,2.6193751 -2.6193751,2.6193751 -1.4464948,0 -2.619481,-1.1725628 -2.619481,-2.6193751 0,-1.4459657 1.1729862,-2.6193755 2.619481,-2.6193755 1.4463889,0 2.6193751,1.1734098 2.6193751,2.6193755",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterpolo);
export default __webpack_public_path__ + "static/media/waterpolo.9c89fe8b1da6cf5863439ba646b925b2.svg";
export { ForwardRef as ReactComponent };